// components/AccordionSection.jsx
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
// If you don't use @mui/icons-material, swap the expandIcon with an <img/>
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
export default function AccordionSection({
  title,
  children,
  defaultExpanded = true, // open by default (tweak per section)
  disabled = false, // set true if you want to lock a section
  sx = {},
}) {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disabled={disabled}
      sx={{
        mb: 1.5,
        boxShadow: "none",
        "&:before": { display: "none" }, // remove top divider line
        "&.Mui-expanded": { boxShadow: "none", margin: 0 },
        ...sx,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          "& .MuiAccordionSummary-content": { alignItems: "center", my: 0.5 },
          fontWeight: 700,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 700,
            fontSize: "24px",
            color: "#4C4E64",
            backgroundColor: "#F9F9F9",
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>{children}</AccordionDetails>
    </Accordion>
  );
}
